<script setup lang="ts">
import CiSkeletonItem from '@/components/skeleton/CiSkeletonItem.vue';

/********************
 * PROPS & EMITS    *
 ********************/
export interface CiSkeletonCampsiteDetailProps {
  hasAds?: boolean;
  hasTopLink?: boolean;
}
const props = withDefaults(defineProps<CiSkeletonCampsiteDetailProps>(), {
  hasAds: false,
  hasTopLink: false,
});
</script>

<template>
  <div
    class="relative"
    :class="{ 'md:pt-6 lg:pt-12': !props.hasTopLink }"
  >
    <template v-if="props.hasAds">
      <div class="absolute size-full">
        <div class="container h-full">
          <div class="flex h-full">
            <CiSkeletonItem
              class="ad ad--skyscraper ad--skyscraper-left sticky-top z-10"
              style="top: 50px"
            />
            <CiSkeletonItem
              class="ad ad--skyscraper ad--skyscraper-right sticky-top z-10"
              style="top: 50px"
            />
          </div>
        </div>
      </div>

      <div class="container-lg mb-4 pt-0">
        <CiSkeletonItem class="ad ad--header" />
      </div>
    </template>

    <div class="container">
      <div class="relative mb-6 mt-0">
        <CiSkeletonItem v-if="props.hasTopLink" class="mb-2 mt-1 h-[50px] w-[200px] max-w-[80%]" />

        <div class="grid grid-cols-2 gap-x-[10px]">
          <div class="col-span-2 lg:col-span-1">
            <CiSkeletonItem class="h-auto w-full rounded pt-[75%]" />
          </div>
          <div class="col-span-2 hidden lg:col-span-1 lg:block">
            <CiSkeletonItem class="h-auto w-full rounded pt-[75%]" />
          </div>
        </div>

        <div class="mt-12">
          <CiSkeletonItem class="mb-3 h-[30px] w-1/2 md:mx-auto md:mt-0" />
          <CiSkeletonItem class="h-[50px] w-[70%] md:mx-auto md:my-0" />

          <div class="mb-6 mt-4 md:mb-0">
            <CiSkeletonItem class="h-[100px] w-[200px] md:mx-auto md:my-0" />
          </div>
        </div>

        <div class="mx-auto mt-12 w-full lg:w-8/12">
          <CiSkeletonItem class="h-[75px] rounded md:h-[52px]" />
        </div>

        <CiSkeletonItem class="mx-auto mt-6 h-10 w-full rounded lg:w-6/12" />

        <hr class="mx-auto my-6 h-px w-full border-0 bg-gray-40 md:w-8/12" />

        <CiSkeletonItem class="mx-auto h-[200px] w-full rounded lg:w-6/12" />

        <CiSkeletonItem class="my-6 h-[500px] w-full" />
        <CiSkeletonItem class="my-6 h-[500px] w-full" />
      </div>
    </div>
  </div>
</template>
